import React from 'react';
import {LandingPageContent} from '@/constants';
import {colors} from '@/theme';
import {Icon} from '@/ui-kits';

interface SpecialistProps {
  id?: string;
}
export const Specialist: React.FC<SpecialistProps> = ({id}) => {
  return (
    <div id={id} className='flex flex-col items-center pt-0 md:pt-2 pb-6 md:pb-8 -mt-2 md:-mt-2'>
      <h2 id="gradient-text-2" className=' mb-8 items-center py-5 md:py-10 text-3xl md:text-4xl 2xl:text-5xl font-FigtreeBold'>
        {LandingPageContent.doctors.title}
      </h2>

      <div className='flex flex-wrap max-w-[1440px] gap-24 md:gap-6 mt-10 justify-center px-4'>
        {LandingPageContent.doctors.doctors.map((item, index) => (
          <div className='flex flex-col flex-1 flex-shrink-0 w-full xs:min-w-[280px] sm:min-w-[300px] max-w-[450px] 2xl:max-w-full' key={item.name}>
            <div className='relative bg-[#CBEBFB] flex flex-col items-center h-[260px] sm:h-[300px] rounded-t-3xl overflow-visible mt-16 sm:mt-20'>
              <img className='w-full max-w-[320px] h-[340px] sm:h-[380px] absolute bottom-0 object-bottom object-contain' alt={`Photo of ${item.name}`} src={item.photo} />

              <div className='z-[1px] bg-ui_blue_background px-4 lg:px-8 py-2 lg:py-3 rounded-t-lg absolute bottom-0 right-[50%] translate-x-[50%]'>
                <span className='text-white font-FigtreeSemiBold text-nowrap text-[12px] lg:text-sm'>Board Certified</span>
              </div>
            </div>

            <div style={{boxShadow: `-1px 1px 10px -5px ${colors.palette.grey}`,}} className='flex-col flex items-center rounded-b-3xl px-4 lg:px-8 2xl:px-12 3xl:px-16 py-4 box-border z-[-1] gap-4 h-[220px] sm:h-[250px]'>
              <h3 className='text-2xl sm:text-xl lg:text-2xl 3xl:text-3xl font-FigtreeExtraBold text-ui_blue text-center break-words'>{item.name}</h3>
              <p className='text-lg sm:text-lg lg:text-xl text-ui_blue text-center font-FigtreeMeduim text-wrap self-stretch 3xl:whitespace-normal'>{item.description}</p>
              {(item as any).social_links?.length > 0 && (
                <div className='flex gap-6 mt-auto'>
                  {(item as any).social_links.map((socialItem: {icon: string; link: string}) => (
                    <Icon className='size-[28px]' key={socialItem.icon} type={socialItem.icon as any} />
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
